import { render } from "./BidShowcaseDizaym.vue?vue&type=template&id=978bbc2e&scoped=true"
import script from "./BidShowcaseDizaym.vue?vue&type=script&lang=js"
export * from "./BidShowcaseDizaym.vue?vue&type=script&lang=js"

import "./BidShowcaseDizaym.vue?vue&type=style&index=0&id=978bbc2e&scoped=true&lang=css"
import "./BidShowcaseDizaym.vue?vue&type=style&index=1&id=978bbc2e&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-978bbc2e"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField,QSelect,QForm,QInput});
